export default {
  "backdrop": "_backdrop_fs9gf_1",
  "absoluteFill": "_absoluteFill_fs9gf_5",
  "popover": "_popover_fs9gf_13",
  "card": "_card_fs9gf_19",
  "chromeless": "_chromeless_fs9gf_24",
  "tooltip": "_tooltip_fs9gf_25",
  "default": "_default_fs9gf_51",
  "large": "_large_fs9gf_57",
  "xlarge": "_xlarge_fs9gf_63",
  "wide": "_wide_fs9gf_69",
  "menu": "_menu_fs9gf_75",
  "content": "_content_fs9gf_84"
};import "ni:sha-256;yUuEOthlJXtFRSS0GGVc-NupDENgE1OgWjKG_gol5X0";